define("shared/components/shared/ai-credits/info", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Modal @close={{@handleClose}} @focusTrap={{true}} as |modal|>
    <modal.card @portrait={{true}}>
  
      <modal.card-header @title={{t "shared_words.credits"}} />
  
      <modal.card-body class="u--p__t__0">
        <p>{{t "checkout.ai_credits_info.description"}}</p>
        <br />
        <p class="u--text--md u--text--bold">
          {{t "checkout.ai_credits_info.add.title"}}
        </p>
  
        <p>{{html-safe (t "checkout.ai_credits_info.add.description")}}</p>
        <p class="u--text--md u--text--bold">{{t "checkout.ai_credits_info.upgrade.title"}}</p>
        <p>{{t "checkout.ai_credits_info.upgrade.description"}}</p>
      </modal.card-body>
  
      <modal.card-footer>
        <div class="o--btnBar u--float--right">
          <Shared::Ui::Button @onClick={{@handleClose}} @text={{t "shared_words.close"}} @variant="outline" />
        </div>
      </modal.card-footer>
  
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "NvEfIxmo",
    "block": "[[[8,[39,0],null,[[\"@close\",\"@focusTrap\"],[[30,1],true]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,2,[\"card\"]],null,[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n\\n    \"],[8,[30,2,[\"card-header\"]],null,[[\"@title\"],[[28,[37,1],[\"shared_words.credits\"],null]]],null],[1,\"\\n\\n    \"],[8,[30,2,[\"card-body\"]],[[24,0,\"u--p__t__0\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[10,2],[12],[1,[28,[35,1],[\"checkout.ai_credits_info.description\"],null]],[13],[1,\"\\n      \"],[10,\"br\"],[12],[13],[1,\"\\n      \"],[10,2],[14,0,\"u--text--md u--text--bold\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"checkout.ai_credits_info.add.title\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[10,2],[12],[1,[28,[35,2],[[28,[37,1],[\"checkout.ai_credits_info.add.description\"],null]],null]],[13],[1,\"\\n      \"],[10,2],[14,0,\"u--text--md u--text--bold\"],[12],[1,[28,[35,1],[\"checkout.ai_credits_info.upgrade.title\"],null]],[13],[1,\"\\n      \"],[10,2],[12],[1,[28,[35,1],[\"checkout.ai_credits_info.upgrade.description\"],null]],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\\n    \"],[8,[30,2,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[10,0],[14,0,\"o--btnBar u--float--right\"],[12],[1,\"\\n        \"],[8,[39,3],null,[[\"@onClick\",\"@text\",\"@variant\"],[[30,1],[28,[37,1],[\"shared_words.close\"],null],\"outline\"]],null],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\\n  \"]],[]]]]],[1,\"\\n\"]],[2]]]]]],[\"@handleClose\",\"modal\"],false,[\"shared/modal\",\"t\",\"html-safe\",\"shared/ui/button\"]]",
    "moduleName": "shared/components/shared/ai-credits/info.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});